import { render } from "./ImageUploadPopUpComponent2.vue?vue&type=template&id=5f843735&scoped=true"
import script from "./ImageUploadPopUpComponent2.vue?vue&type=script&lang=js"
export * from "./ImageUploadPopUpComponent2.vue?vue&type=script&lang=js"

import "./ImageUploadPopUpComponent2.vue?vue&type=style&index=0&id=5f843735&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5f843735"

export default script